import { coastConfig } from './coast';
import { fleetioConfig } from './fleetio';
import { PARTNER_IDS, type PartnerConfig, type PartnerId } from './types';

const PARTNER_CONFIGS: Record<PartnerId, PartnerConfig> = {
  [PARTNER_IDS.COAST]: coastConfig,
  [PARTNER_IDS.FLEETIO]: fleetioConfig,
};

export const getPartnerConfig = (id: PartnerId): PartnerConfig =>
  PARTNER_CONFIGS[id];

export * from './types';
